import React,{useState, useEffect} from "react";

import eightAxios from "../../configs/axiosConfig.js"

import Form from "components/Form";
import { ACCOUNT_DELETION_URL , STORAGE_CONSTANT} from "configs/constants";


import CloseIcon from "@material-ui/icons/Close";
import BlockIcon from "@material-ui/icons/Block";
import CheckIcon from "@material-ui/icons/Check";
import { useTranslation } from "react-i18next";
import {  useHistory } from "react-router-dom";
import { useNotifyContext } from "@Components/Notify"


let actionPermission = true;

const AccountDeletionViewDetails = () => {
  const [submitUrl, setSubmitUrl] = useState(ACCOUNT_DELETION_URL); 
  const [initialValues, setInitialValues] =useState({
    id : null,
    employee_id : '',
    mobile_number : ''
  })
  const { t } = useTranslation();
  const history = useHistory();

  const [loading, setLoading] = useState(false)
  const [onError, setOnError] = useState({})
  const [confirmDialog, setConfirmDialog] = useState({
     isOpen: false,
     title: "",
     subTitle: "",
   })
   
   const setNotify = useNotifyContext()

  const pageUrl = window.location.href
  const userId = pageUrl.split("/").pop()
  useEffect(() =>{
    eightAxios.get(`account-deletion/${userId}`)
    .then((response) => {
      setInitialValues({
        id : userId,
        employee_id :response.data.employee_id,
       mobile_number : response.data.mobile_number
      })
      
    })
    .catch((error) => {
     console.log("Error in get User details", error)     
    })
  },[])

    
  const formFields = [
    { type: "title", title: "Personal Details" },
    {
      type: "renderonly",
      name: "employee_id",
      key: "employee_id",
      label: "Employee ID",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "name",
      key: "name",
      label: "Name",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "nationality",
      key: "nationality",
      label: "Nationality",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "worker_type",
      key: "worker_type",
      label: "Worker type",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "id_type",
      key: "id_type",
      label: "ID Type",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "id_number",
      key: "id_number",
      label: "ID Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "mobile_number",
      key: "mobile_number",
      label: "Mobile Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "role",
      key: "role",
      label: "Role",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "status",
      key: "status",
      label: "Status",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    { type: "title", title: "Employment Details" },
    {
      type: "renderonly",
      name: "worker_group",
      key: "worker_group",
      label: "Worker Group",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "company",
      key: "company",
      label: "Company",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "zone",
      key: "zone",
      label: "Zone",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "region",
      key: "region",
      label: "Region",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "estate",
      key: "estate",
      label: "Estate",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "division",
      key: "division",
      label: "Division",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "block",
      key: "block",
      label: "Block",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    { type: "title", title: "Audit Details" },
    {
      type: "renderonly",
      name: "request_datetime",
      key: "request_datetime",
      label: "User Request Date & Time",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "ur_satus",
      key: "ur_status",
      label: "User Request Status",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
  ];



  const urls = {  
    declineURL: "new-user/{id}/decline-pending-user/",
  };


  // const formButtons = ["approve" ,"reject","cancel"];

  const validateAction =()=>{
  const updatedModules = JSON.parse(localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES));

    if (updatedModules) {
      if(updatedModules["Delete Account Request"].includes("edit")){
        actionPermission = true;
      }else actionPermission = false
    }
  }

  validateAction()

  const formButtons = [
    {
      type: "approve",
      title: "approve",
      label: t("Approve"),
      color:  actionPermission ? "primary" : "",
      startIcon: (
        <CheckIcon />
      ), 
      onClick: () => {
        {actionPermission && handleApprove()}
      },
    },
    {
      type: "reject",
      title: "Decline",
      label: t("Decline"),
      startIcon: (
        <BlockIcon style={{ color: "#000"}} />
      ), 
      onClick: () => {
        {actionPermission && handleDecline()}
      },
    },
    {
      type: "cancel",
      title: "Cancel",
      label: t("Cancel"),
      startIcon: (
        <CloseIcon />
      ),
       onClick: ()  => history.push("/user/pending-approval/account-deletion"),
      },
       
  ]

 /*  useEffect(()=>{
    console.log("test init",initialValues);
    
  },[initialValues]) */
  const handleApprove = () => {
    setLoading(true)
    eightAxios
          // .delete(`approve-delete/${initialValues.id}/${initialValues.employee_id}/${initialValues.mobile_number}/`)
          .delete(`approve-request/${initialValues.id}/`)
           .then(() => {
             setConfirmDialog({
               ...confirmDialog,
               isOpen: false,
             })
             setNotify({
               isOpen: true,
               message: "User is successfully deleted",
               type: "success",
             })
           })
           setTimeout(()=>{
             history.push("/user/pending-approval/account-deletion")
             window.location.reload();
           },800)
           .catch((error) => {
             setNotify({
               isOpen: true,
               message: "Error in deletig user",
               type: "error",
             })
             
           })   
  };

  const handleDecline = () => {
    eightAxios
    .delete(`reject-request/${initialValues.id}/`)
    .then((response) => {
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false,
      })
      setNotify({
        isOpen: true,
        message: "User has been rejected.",
        type: "success",
      })
      setTimeout(()=>{
        history.push("/user/pending-approval/account-deletion")
      },800)
    })
    .catch((error) => {
      setNotify({
        isOpen: true,
        message: error.response.data.message,
        type: "error",
      })
    }) 
  };

  const handleFormSubmit = (event) => {
    event.preventDefault(); // Prevent the default POST request
    console.log(" test Button clicked : Custom form submission logic");
  };



  return (
    <div>
      <Form
        initialValues={initialValues}
        submitUrl={submitUrl}
        listRoute="/user/pending-approval/account-deletion"
        formFields={formFields}
        formButtons={formButtons}
        formTitle="Delete Account Request"
        // handleFormSubmit={handleFormSubmit}
         handleApprove={handleApprove}
       /* handleReject={handleReject} */
      />
    </div>
  );
};

export default AccountDeletionViewDetails;
